export default __webpack_public_path__ + "static/media/close.eb35e9e7.svg";